import { randCity } from '@ngneat/falso';
import { IWorkspaceProvisioningTask } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { MockWithRef } from '@principle-theorem/testing';
import { v4 as uuid } from 'uuid';
import { WorkspaceProvisioningTask } from './workspace-provisioning-task';

export function MockClickUpTaskRef(
  overrides: Partial<IWorkspaceProvisioningTask['clickUp']> = {}
): IWorkspaceProvisioningTask['clickUp'] {
  const taskId = overrides.taskId ?? uuid();

  return {
    taskId,
    taskUrl: overrides.taskUrl ?? `https://app.clickup.com/t/${taskId}`,
    taskName: overrides.taskName ?? 'Workspace provisioning task',
    country: overrides.country ?? 'New Zealand',
  };
}

export function MockWorkspaceProvisioningTask(
  overrides: Partial<IWorkspaceProvisioningTask> = {}
): WithRef<IWorkspaceProvisioningTask> {
  const { clickUp: clickUpOverrides, ...taskOverrides } = overrides;
  const clickUp = MockClickUpTaskRef(clickUpOverrides);
  const task = WorkspaceProvisioningTask.init({
    clickUp,
    practiceName: taskOverrides.practiceName ?? randCity(),
    ...taskOverrides,
  });

  return MockWithRef(task, `workspaceProvisioningTasks/${task.clickUp.taskId}`);
}
